const Input = ({
  name,
  required,
  register,
  className,
  placeholder,
  type = "text",
  ...rest
}) => (
  <input
    name={name}
    type={type}
    required={required}
    placeholder={placeholder}
    {...(register && name ? { ...register(name) } : {})}
    className={`w-64 h-11 px-4 py-2.5 border border-gray-400 bg-white rounded-full font-medium focus:outline-none placeholder:text-gray-400  ${className}`}
    {...rest}
  />
)

export default Input
